import { TbReportMoney } from 'react-icons/tb';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { ReactComponent as Polisov } from 'assets/icons/polisov.svg';
import { ReactComponent as MainIcon } from 'assets/icons/icon_main.svg';
import { ReactComponent as CurrencyIcon } from 'assets/icons/currency-icon.svg';

export const containerData = [
  {
    title: 'Главная страница',
    url: '',
    icon: <MainIcon />,
  },
  {
    title: 'Ведение полисов',
    url: 'maintenance-policies',
    addText: 'Добавить полис',
    icon: <Polisov />,
  },
  {
    title: 'Ведение дел',
    url: 'case-management',
    addText: 'Добавить дело',
    icon: <Polisov />,
  },
  {
    title: 'Пользователи',
    url: 'users',
    addText: 'Добавить пользователя',
    icon: <HiOutlineUserGroup size='30px' color='#005AA9' />,
  },
  {
    title: 'Отчеты',
    url: 'reports',
    icon: <TbReportMoney size='30px' color='#005AA9' />,
  },
  {
    title: 'Страхователи',
    url: 'insurer',
    addText: 'Добавить страхователя',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Регионы',
    url: 'area',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Страховые компании',
    url: 'insurance-companies',
    addText: 'Добавить компанию',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Страховые программы',
    url: 'insurance-programs',
    addText: 'Добавить программы',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Медицинские учреждения',
    url: 'medical-institutions',
    addText: 'Добавить учреждение',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Заболевания',
    url: 'illness',
    addText: 'Добавить заболевание',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Медикаменты',
    url: 'medicines',
    addText: 'Добавить медикаменты',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Медицинские услуги',
    url: 'medical-services',
    icon: <CurrencyIcon />,
  },
  {
    title: 'Валюты',
    url: 'currencies',
    addText: 'Добавить валюту',
    icon: <CurrencyIcon />,
  },
];
